<template>
    <div v-if="cfg" :class="cfg.cls" :title="cfg.label">
        <component
            :is="cfg.Icon"
            v-if="cfg.Icon"
            class="w-2.5 h-2.5 opacity-90 shrink-0"
        />
        <span>{{ cfg.label }}</span>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import {Check, Film, Play, TrendingUp} from "lucide-vue-next"; // Adjust import path as needed

const props = defineProps({
    audition: {
        type: Object,
        required: true
    }
})

const BADGE_BASE = 'inline-flex items-center gap-1 whitespace-nowrap ' + 'px-1.5 py-1 rounded-md min-h-[22px] ' + 'text-xs leading-none font-bold tracking-wide uppercase ' + 'bg-black/60 backdrop-blur-md border shadow-sm';

const cfg = computed(() => {
    if (props.audition.is_near_goal) {
        return {
            label: 'Near Goal',
            cls: `${BADGE_BASE} border-amber-400/30 text-amber-200`,
            Icon: TrendingUp
        };
    } else if (props.audition.star_goal_reached && !props.audition.release_status) {
        return {
            label: 'Sponsored',
            cls: `${BADGE_BASE} border-sky-400/20 text-sky-300 bg-sky-500/10`,
            Icon: Check
        };
    } else if (props.audition.release_status == 1) {
        return {
            label: 'In Production',
            cls: `${BADGE_BASE} border-amber-400/25 text-amber-300 bg-amber-500/10`,
            Icon: Film
        }
    } else if (props.audition.release_status == 2) {
        return {
            label: 'Released Scene',
            cls: `${BADGE_BASE} border-emerald-400/20 text-emerald-300 bg-emerald-500/10`,
            Icon: Play
        }
    }

    return null;
})
</script>
